<script>
import SponsorScroll from '../../../SponsorScroll'

export default {
  components: {
    SponsorScroll
  }
}
</script>

<template>
  <div class="isef-home-banner"
       role="banner">
    <div class="isef-home-banner-hero">
      <span class="isef-home-banner-hero-left">
        <h1 class="isef-home-banner-hero-title">
          Regeneron ISEF 2023 Virtual Showcase
        </h1>
        <span class="isef-home-banner-hero-btn-container">
          <button @click="$router.push({ name: 'isefCategories' })"
                  class="button isef-home-banner-hero-btn isef-home-banner-hero-btn-primary">
            Explore Finalist Projects <i class="fa-regular fa-arrow-right-long isef-home-banner-hero-btn-icon"></i>
          </button>
          <button @click="$router.push('/college-career-fair')"
                  class="button isef-home-banner-hero-btn isef-home-banner-hero-btn-secondary">
            Visit College &amp; Career Fair <i class="fa-regular fa-arrow-right-long isef-home-banner-hero-btn-icon"></i>
          </button>
        </span>
        <hr class="isef-home-banner-hero-underline"/>
        <span class="isef-home-banner-present-container">
          <h6 class="isef-home-banner-present">Proudly Presented By</h6>
          <a href="https://www.societyforscience.org/" target="_blank">
            <img src="https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fsociety_logo.png?alt=media&token=61cf3c7b-b45d-481f-a317-ecd4e06584cb"
                 alt="sponsor logo"
                 class="isef-home-banner-present-image"/>
          </a>
        </span>
      </span>
      <span class="isef-home-banner-hero-right">
        <img src="https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2FMask%20group.png?alt=media&token=27b322e3-5932-4742-9b73-1e7ef5529178"
             alt="badge"
             class="isef-home-banner-hero-right-badge"/>
        <img src="https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fbg%20texas%20image%20_Large.png?alt=media&token=18f65686-5353-4980-88b5-838c8574d998"
             class="isef-home-banner-hero-right-city" />
        <img src="https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fbanner%2Fmobile-city.png?alt=media&token=c7b847fe-a43b-4e9f-aaaa-aa3390f04418"
             alt="mobile-city"
             class="isef-home-banner-hero-right-city-mobile" />
      </span>
    </div>
    <sponsor-scroll />
  </div>
</template>

<style lang="scss" scoped>
.isef-home-banner {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;
  width: 100%;
  max-height: 80rem;
  position: relative;
  &-hero {
    margin-top: 5rem;
    display: flex;
    flex-direction: row;
    @media screen and (max-width: 1000px){
      flex-direction: column !important;
    }
    &-left {
      max-width: 50%;
      margin-left: 2rem;
      position: relative;
      z-index: 2;
      @media only screen and (max-width: 1000px){
        max-width: 100% !important;
        margin: 0;
      }
    }
    &-right {
      padding-left: 6rem;
      width: 100%;
      height: 40rem;
      @media only screen and (max-width: 1020px){
        padding: 2rem 0 ;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 20rem;
      }
      @media only screen and (max-width: 600px){
        padding-left: 0;
        margin-bottom: -3rem;
        height: auto;
      }
      &-badge {
        position: relative;
        max-width: 379px;
        height: auto;
        z-index: 3;
        @media only screen and (max-width: 1020px){
          width: 150px !important;
          margin-top: -7rem;
        }
        @media only screen and (max-width: 600px){
          display: none;
        }
      }
      &-city {
        position: absolute;
        height: 40rem;
        z-index: 1;
        bottom: 2rem;
        margin-left: -45rem;
        @media only screen and (max-width: 1020px){
          margin-left: 18rem;
          height: 23rem;
          bottom: 8rem;
        }
        @media only screen and (max-width: 600px){
          display: none;
        }
        &-mobile {
          display: none;
          @media only screen and (max-width: 600px) {
            display: inline-flex;
            width: 80%;
            margin-left: 2rem;
          }
        }
      }

    }
    &-title {
      font-size: 62px;
      font-weight: 500;
      line-height: 6.125rem;
      color: #FFFFFF;
      font-family: 'Trade Gothic Next LT Pro BdCn', serif;
      font-style: normal;
      @media only screen and (max-width: 1020px){
        max-width: 35rem !important;
        text-align: center;
      }
      @media only screen and (max-width: 530px){
        margin-left: 3.65rem;
        width: 80% !important;
        font-size: 46px !important;
        line-height: 3.5rem;
        padding: 0 2rem;
        margin-top: -3rem;
      }
    }

    &-underline {
      height: 3px;
      max-width: 568px;
      background: linear-gradient(90deg, #3375C1 0%, #CC4B79 40.1%, #DF8E44 70.83%, #FFD563 100%);
      margin: 3rem 0;
      @media only screen and (max-width: 600px) {
        margin: 3rem 6.5rem;
      }
    }

    &-btn {
      font-family: 'Helvetica Neue';
      border-radius: 8px;
      border: 2px solid #509DD7;
      height: 56px;
      width: 267px;
      color: #FFFFFF;
      font-weight: 500;
      font-size: 1em;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      @media only screen and (max-width: 600px) {
        font-size: .825em;
      }

      &-icon {
        margin-left: .5rem;
      }

      &-container {
        margin: 1.5rem 0;
        display: flex;
        flex-direction: row;
        width: 564px;
        justify-content: space-between;
        @media only screen and (max-width: 606px){
          flex-direction: column !important;
          justify-content: center !important;
          align-items: center;
          font-size: 1.2em;
        }
      }

      &-primary {
        background: #509DD7;
      }

      &-secondary {
        background: transparent;
        border-color: white;
        &:hover {
          background: #509DD7;
          border-color: #509DD7;
        }
        @media only screen and (max-width: 608px){
          margin-top: 1rem;
        }
      }
    }
  }
  &-present {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 100%;
    color: #FFFFFF;
    padding-right: 1rem;
    font-family: 'Helvetica Neue';
    &-container {
      display: flex;
      flex-direction: row;
      align-items: center;
      @media only screen and (max-width: 600px){
        justify-content: center;
      }
    }
    &-image {
      @media only screen and (max-width: 600px) {
        width: 11rem;
        height: auto;
      }
    }
  }
  &-sponsor {
    z-index: 3;
    width: 100%;
    height: 10rem;
    background-color: #FFFFFF;
  }
}
</style>
